import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import ReactCountryFlag from "react-country-flag";
import { Link } from "react-router-dom";
import { getName } from "country-list";
import CustomeButton from "../../../../components/Button/index";

const LspCustomers = ({
  lspInfo,
  isloading,
  handleEdit,
  limit,
  page,
  onChange,
}) => {
  return (
    <div className="lsp-card h-full mt-4 border-gray">
      <div className="flex justify-content-between formgrid grid grid-nogutter">
        <div className="flex-grow">
          <p className="profile-heading">Customers</p>
          <p className="profile-para">
            Find all customers connected to this Local Team
          </p>
        </div>
        <div className="items-center">
          <CustomeButton
            label="Manage Customer Portfolio"
            variant="outlined"
            onClick={handleEdit}
          />
        </div>
        {isloading ? (
          <DataTable
            value={Array(6).fill({})}
            tableStyle={{ minWidth: "100%" }}
            className="datatable-right-align w-full pt-2"
            rows={6}
          >
            <Column header="Registered Name" body={<Skeleton />} />
            <Column header="Type" body={<Skeleton />} />
            <Column header="Country" body={<Skeleton />} />
            <Column header="Account Manager" body={<Skeleton />} />
            <Column />
          </DataTable>
        ) : (
          <DataTable
            value={lspInfo?.access || []}
            sortMode="multiple"
            tableStyle={{ minWidth: "50rem" }}
            className="datatable-right-align w-full pt-2"
            emptyMessage="No results were found"
            paginator={lspInfo?.access?.length > 10}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            rowsPerPageOptions={[10, 20, 30]}
            first={page}
            rows={limit}
            onPage={onChange}
          >
            <Column
              field="entity.name"
              header="Registered Name"
              sortable
              body={(rowData) => (
                <Link
                  className="entity-link"
                  to={`/entity/${rowData?.entity?.id}/dashboard`}
                >
                  {rowData?.entity?.name}
                </Link>
              )}
            />
            <Column sortable field="entity.type" header="Type" />
            <Column
              sortable
              header="Country"
              field="entity.country"
              body={(rowData) => (
                <div className="country-tag">
                  <ReactCountryFlag countryCode={rowData.entity.country} svg />
                  <span
                    style={{ textTransform: "capitalize", marginLeft: "7px" }}
                  >
                    {getName(rowData.entity.country)}
                  </span>
                </div>
              )}
              // body={(rowData) => {
              //   return (
              //     <div className="country-tag">
              //       <ReactCountryFlag
              //         countryCode={rowData.entity.country}
              //         svg
              //       />
              //       <span
              //         style={{ textTransform: "capitalize", marginLeft: "7px" }}
              //       >
              //         {getName(rowData.entity.country)}
              //       </span>
              //     </div>
              //   );
              // }}
            />
            <Column
              field="entity.account_manager_name"
              header="Account Manager"
              sortable
            />
          </DataTable>
        )}
      </div>
    </div>
  );
};
LspCustomers.propTypes = {
  lspInfo: PropTypes.object,
  isloading: PropTypes.bool,
  handleEdit: PropTypes.func,
  onChange: PropTypes.func,
  limit: PropTypes.number,
  page: PropTypes.number,
};
export default LspCustomers;
